/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

const cars = ['chevrolet', 'ford', 'ram', 'toyota']
export const HMS_TEAM = 'hmsTeam'

export const defaultImageFilters = {
  brightness: 1,
  contrast: 1,
}

export const DEFAULT_RACE_FILTER_OPTIONS = {
  car_count: {
    label: 'Cars',
    order: -1,
  },
  car_model: {
    mergeProps({ filter_values, ...other }) {
      return {
        ...other,
        class_name: 'filter-car-model',
        filter_values: filter_values.map(el => {
          const { value } = el
          return cars.includes(value)
            ? { icon: `$vuetify.icons.${value}`, value }
            : el
        }),
        label: 'Model',
        order: 5,
      }
    },
  },
  car_number: {
    class_name: 'filter-car-number',
    label: 'Car NO.',
    order: 3,
  },
  car_orientation: {
    label: 'View',
    order: 4,
  },
  session: {
    class_name: 'filter-session',
    label: 'Session',
    order: 1,
  },
  team_cars: {
    class_name: 'filter-hms-team',
    filter_values: [
      {
        icon: '$vuetify.icons.5',
        value: '5',
      },
      {
        icon: '$vuetify.icons.9',
        value: '9',
      },
      {
        icon: '$vuetify.icons.24',
        value: '24',
      },
      {
        icon: '$vuetify.icons.48',
        value: '48',
      },
    ],
    filter_var: 'car_number',
    id: HMS_TEAM,
    label: 'HMS cars',
    order: -1,
  },
  track_sector: {
    label: 'Sector',
    order: 2,
  },
}

export const CANVAS_MODES = {
  calibration: 'calibration',
  drawing: 'drawing',
  measuring: 'measuring',
  moving: 'moving',
  selecting: 'selecting',
  single: 'single',
}

export const CARS_COUNT = 'car_count'

export const IMAGE_VIEWS = {
  auto: 'AUTO_ZOOM',
  regular: 'REGULAR_VIEW',
}

export const sortByCreatedDate = {
  asc: 'created_date',
  desc: '-created_date',
}
